export default __webpack_public_path__ + "static/media/about-sec-img.7ff0f9fd.jpg";